import { Link } from "react-router-dom";
import "./dataTable.css"
import { format, formatDistance } from "date-fns";
import { ACTIONS, getAging, getSurveyForm, handleAction, surveyFormStatuses, updateSurveyStatus } from "./helper";
import TextTruncate from "../../utilsComponent/textTruncate";
import NoDataFound from "../../utilsComponent/noDataFound";
import { getFromDecreaptLocalStorage, titleCase } from "../../utilFunctions";
import { CLAIMS_HANDLER, fieldSurveyStatus, PMFBY } from "../../consts";
import { useEffect, useState } from "react";
import ListsPagination from "../../utilsComponent/ListsPagination";

const DataTable = ({ data = [], selectedData = [], setSelectedData, totalRecordsCount, handlePageOrSizeChange, getList, setIsLoading, actionItem }) => {
    const reAssignableStatus = [fieldSurveyStatus.ASSIGNED, fieldSurveyStatus.WORK_IN_PROGRESS, fieldSurveyStatus.SAVED_AS_DRAFT]
    const [actionableData, setActionableData] = useState([]);
    const roleDataCookie = getFromDecreaptLocalStorage("roleData");

    useEffect(() => {
        if(actionItem) {
            setActionableData(data)
        } else {
            setActionableData(data.filter(survey => reAssignableStatus.includes(survey.surveyStatus)))
        }
    }, [data, actionItem])

    useEffect(() => {
        setSelectedData([])
    }, [actionableData])

    const onAction = async (details) => {
        if (roleDataCookie?.roleName === CLAIMS_HANDLER && [surveyFormStatuses.APPROVAL_PENDING].includes(details.downloadStatus)) {
            await handleAction( ACTIONS.APPROVE, [details],()=>{}, setIsLoading)
            await getList();
        }
        else if ((roleDataCookie?.roleName === "Admin" || [null, surveyFormStatuses.APPROVED].includes(details.downloadStatus))) {
            await handleAction( ACTIONS.DOWNLOAD, [details], () => {}, setIsLoading)
             await getList();
        } else if ([surveyFormStatuses.DOWNLOADED].includes(details.downloadStatus)) {
            await handleAction( ACTIONS.REDOWNLOAD, [details], () => {}, setIsLoading)
            await getList();
        }
    }

    const ActionItems = ({ details }) => {
        return <>
            {details?.productName === PMFBY ? (details?.surveyStatus === fieldSurveyStatus.IN_COMPLETE ? " --" : (roleDataCookie?.roleName === "CLAIMS_HANDLER" ?
                ([surveyFormStatuses.APPROVAL_PENDING].includes(details.downloadStatus) ? (<Link to={"#"} className="text-primary" onClick={() => { onAction(details) }} >Approve</Link>) : "--") : ((roleDataCookie?.roleName === "Admin" || [null, surveyFormStatuses.APPROVED].includes(details.downloadStatus)) ? (
                    <Link to={"#"} className="text-primary" onClick={() => { onAction(details) }}>Download</Link>
                ) : ([surveyFormStatuses.DOWNLOADED].includes(details.downloadStatus) ? (<Link to={"#"} className="text-primary" onClick={() => { onAction(details) }}>Re Download</Link>) : [surveyFormStatuses.APPROVAL_PENDING].includes(details.downloadStatus) ? "Waiting for approval" : "--")))) : "--"}
        </>
    }
    return (
        data.length ? (
            <>
                <div className="table-responsive">
                    <table className="table table-strip mt-3 text-left">
                        <tbody>
                            <tr>
                                <th className="sticky-col sticky-col-1">
                                    <input type="checkbox"
                                        checked={actionableData?.length && (actionableData?.length === selectedData.length)}
                                        onChange={() => {
                                            if (actionableData?.length && (actionableData.length === selectedData.length)) {
                                                setSelectedData([])
                                            } else {
                                                setSelectedData(actionableData)
                                            }
                                        }} />
                                </th>
                                <th className="sticky-col sticky-col-2">
                                    Survey ID
                                </th>
                                <th>
                                    Policy / Application no
                                </th>
                                <th>
                                    Product
                                </th>
                                <th>
                                    Farmer ID
                                </th>
                                <th>
                                    Farmer
                                </th>
                                <th>
                                    Crop
                                </th>
                                <th>
                                    Season & year
                                </th>
                                <th >
                                    State
                                </th>
                                <th>
                                    District
                                </th>
                                <th>
                                    Mandal
                                </th>
                                <th>
                                    Village
                                </th>
                                <th>
                                    Intimated Date/Time
                                </th>
                                <th>
                                    Vendor
                                </th>
                                <th>
                                    Surveyor
                                </th>
                                <th>
                                    <TextTruncate text={"Survey Initiated Date/Time"} length={20} />
                                </th>
                                <th>
                                    <TextTruncate text={"Survey Completed Date/Time"} length={20} />
                                </th>
                                <th>
                                    Aging
                                </th>
                                <th>
                                    Survey Status
                                </th>
                                <th>
                                    Action
                                </th>

                            </tr>
                            {
                                data.map((details, index) => (
                                    <tr key={index}>
                                        <td className="sticky-col sticky-col-1">
                                            <input type="checkbox"
                                                checked={selectedData?.some(selectedItem => selectedItem.surveyNumber === details.surveyNumber)}
                                                onChange={() => {
                                                    // if checked already, remove from selection list
                                                    if (selectedData?.some(selectedItem => selectedItem.surveyNumber === details.surveyNumber)) {
                                                        const filteredData = selectedData.filter(selectedItem => selectedItem.surveyNumber !== details.surveyNumber)
                                                        setSelectedData(filteredData)
                                                    } else {
                                                        setSelectedData((prev) => ([...prev, details]))
                                                    }
                                                }}
                                                disabled={!actionItem &&!reAssignableStatus.includes(details.surveyStatus)}
                                            />
                                        </td>
                                        <td className="sticky-col sticky-col-2">
                                            <TextTruncate text={details.surveyNumber || "--"} />
                                        </td>
                                        <td>
                                            <TextTruncate text={details.policyNumber || "--"} />
                                        </td>
                                        <td>
                                            <TextTruncate text={details.productName || "--"} />
                                        </td>
                                        <td>
                                            <TextTruncate text={details.farmerId || "--"} />
                                        </td>
                                        <td>
                                            <TextTruncate text={details.farmerName || "--"} length={20} />
                                            {details.mobileNumber && (details.mobileNumber ? `(${details.mobileNumber})` : "")}
                                        </td>
                                        <td>
                                            <TextTruncate text={details.cropName || "--"} length={15} />
                                        </td>
                                        <td>
                                            <TextTruncate text={(details.seasonName && details.seasonYear) ? (details.seasonName + " - " + details.seasonYear) : (details.seasonName ? details.seasonName : (details.seasonYear ? details.seasonYear : "--"))} />
                                        </td>
                                        <td>
                                            <TextTruncate text={details.state || "--"} />
                                        </td>
                                        <td>
                                            <TextTruncate text={details.district || "--"} />
                                        </td>
                                        <td>
                                            <TextTruncate text={details.mandal || "--"} />
                                        </td>
                                        <td>
                                            <TextTruncate text={details.village || "--"} />
                                        </td>
                                        <td>
                                            {details.intimatedDate ? format(
                                                new Date(details.intimatedDate),
                                                "dd-MM-yyyy, hh:mm a"
                                            ) : "--"}
                                        </td>
                                        <td>
                                            <TextTruncate text={details.vendorName || "--"} length={15} />
                                        </td>
                                        <td>
                                            <TextTruncate text={details.surveyorName || "--"} length={15} />
                                            {details.surveyorMobileNumber ? `(${details.surveyorMobileNumber})` : ""}
                                        </td>
                                        <td>
                                            {details.surveyInitiatedDate ? format(
                                                new Date(details.surveyInitiatedDate),
                                                "dd-MM-yyyy, hh:mm a"
                                            ) : "--"}
                                        </td>
                                        <td>
                                            {details.surveyStatus === fieldSurveyStatus.COMPLETED && details.surveyReceivedDate ?
                                                format(
                                                    new Date(details.surveyReceivedDate),
                                                    "dd-MM-yyyy, hh:mm a"
                                                ) : "--"}
                                        </td>
                                        <td>
                                            {getAging(details.surveyInitiatedDate, details.surveyStatus === fieldSurveyStatus.COMPLETED ? details.surveyReceivedDate : "", formatDistance)}
                                        </td>
                                        <td>
                                            {titleCase(details.surveyStatus || "--")}
                                        </td>
                                        <td>
                                            <ActionItems details={details} />
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                <ListsPagination
                    fetchData={handlePageOrSizeChange}
                    dataCount={totalRecordsCount}
                />
            </>) : (
            <NoDataFound text={"No data Found"} />
        )
    );

}
export default DataTable